var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$permissions().teamLogo)?_c('v-img',{attrs:{"width":_vm.size ? _vm.size : _vm.sizeDefault,"height":_vm.size ? _vm.size : _vm.sizeDefault,"max-width":_vm.size ? _vm.size : _vm.sizeDefault,"max-height":_vm.size ? _vm.size : _vm.sizeDefault,"src":_vm.src},on:{"error":_vm.onError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }